import { render } from "./ui-counter.vue?vue&type=template&id=0e6aa1a0"
import script from "./ui-counter.vue?vue&type=script&lang=js"
export * from "./ui-counter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__